import axios from "axios";
import { get } from "lodash";
// custom.js
const rules = {
    // your custom rules.
    email: value => {
        // #3728: Allow special characters, and disallow consecutive dots
        let regtest = /^(?!.*?\.\.)[a-zA-Z0-9._!#$%&'*+/=?^`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,50}$/i.test(
            value
        );

        if (regtest) {
            let [prefix] = value.split("@"); // prefix = "username" @email.com (the word before '@')
            let firstChar = prefix[0];
            let lastChar = prefix.substr(-1);

            // if prefix starts with a dot = invalid
            if (firstChar === ".") {
                return false;
            }

            // if prefix ends with a dot = invalid
            if (lastChar === ".") {
                return false;
            }

            return true;
        } else {
            return false;
        }
    },
    international_phone: value =>
        /^([a-zA-Z0-9\-_()+*#]+\s)*[a-zA-Z0-9\-_()+*#.,]+$/.test(value),
    phone_number: {
        validate: value => /^\d{6,15}$|^(\d{1,4}[-.\s]?){2,5}\d{1,4}$/.test(value),
        message: 'Please enter a valid phone number'
    },
    verify_sms: {
        validate(value, [country_code]) {
            return (
                axios
                    .post(
                        process.env.COMMUNICATION_SERVICE +
                            "phone-number-lookup",
                        [
                            {
                                type: "home",
                                phone_number:
                                    "+" +
                                    country_code +
                                    value.replace(/\D/g, "")
                            }
                        ]
                    )
                    .then(response => {
                        if (
                            get(
                                response,
                                "data.response.resources[0].valid"
                            ) === true
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    })
                    // -- if server not responding always return true;
                    .catch(() => true)
            );
        },
        options: {
            hasTarget: true
        }
    },
    no_whitespace: {
        getMessage(field, args) {
            return "The value of " + field + " cannot contain spaces.";
        },
        validate(value, args) {
            const regex = /^\S*$/;

            if (!regex.test(value)) {
                return false;
            }

            return true;
        }
    }
};

// export an 'install' function.
export default Validator => {
    // for every rule we defined above.
    Object.keys(rules).forEach(rule => {
        //  add the rule.
        Validator.extend(rule, rules[rule], rules[rule]["options"]);
    });
};
